import Column from 'bloko/blocks/column';

import Account from 'components/Admin/InvoiceDetail/Invoice/Account';
import InvoiceBody from 'components/Admin/InvoiceDetail/Invoice/InvoiceBody';
import TitleWithStatus from 'components/Admin/InvoiceDetail/Invoice/TitleWithStatus';

import { useSelector } from 'store/utils';

import 'components/Admin/InvoiceDetail/Invoice/Invoice.less';

const Invoice = () => {
    const { invoice, account } = useSelector((state) => state.invoiceDetail);

    return (
        <div className="invoice-detail">
            <Column xs="4" s="8" m="12" l="10">
                <TitleWithStatus invoice={invoice} />
                <InvoiceBody invoice={invoice} />
            </Column>
            <Column xs="4" s="8" m="12" l="6">
                <Account {...account} payerId={invoice.payerId} />
            </Column>
        </div>
    );
};

export default Invoice;
